<template>
  <v-app id="inspire">
    <AdminHeader type="search"/>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>
          <AdminMenu/>
          <v-container class="col-10">
            <v-row>
              <v-col class="page-top d-flex justify-space-between" cols="12">
                <div>
                  <div class="page-title">Рабочий стол</div>
                  <div class="breadcrumb">Рабочий стол</div>
                </div>
              </v-col>
            </v-row>
            <v-data-table
                :headers="headersCashbox"
                :items="cashbox"
                item-key="id"
                v-model="selectCashbox"
                no-data-text="Ничего не найдено"
                hide-default-footer
                show-select
                class="elevation-1"
            >
            </v-data-table>
            <!--                        <Grid :column="4" :gap="20" :customStyle="{ alignItems: 'flex-start' }">-->
            <!--                            <Block :padding="0" :withBorder="true" :overflowHidden="true">-->
            <!--                                <div class="column">-->
            <!--                                    <div class="column__item heading">-->
            <!--                                        Планы продаж-->
            <!--                                    </div>-->
            <!--                                    <div class="column__item">-->
            <!--                                        План-фактный анализ продаж-->
            <!--                                    </div>-->
            <!--                                    <div class="column__item">-->
            <!--                                        План-фактный анализ продаж (новые, продления, возобновления)-->
            <!--                                    </div>-->
            <!--                                </div>-->
            <!--                            </Block>-->
            <!--                            <Block :padding="0" :withBorder="true" :overflowHidden="true">-->
            <!--                                <div class="column">-->
            <!--                                    <div class="column__item heading">-->
            <!--                                        Продажи-->
            <!--                                    </div>-->
            <!--                                    <div class="column__item">-->
            <!--                                        Конверсия: Заявка -> Членство -> Пакет услуг-->
            <!--                                    </div>-->
            <!--                                    <div class="column__item">-->
            <!--                                        Конверсия: заявка, пробное занятие, покупка-->
            <!--                                    </div>-->
            <!--                                    <div class="column__item">-->
            <!--                                        Неоплаченные продажи-->
            <!--                                    </div>-->
            <!--                                    <div class="column__item">-->
            <!--                                        Неоплаченные продажи-->
            <!--                                    </div>-->
            <!--                                    <div class="column__item">-->
            <!--                                        Продажи по сотрудникам (расшифровка план/факт продаж)-->
            <!--                                    </div>-->
            <!--                                    <div class="column__item">-->
            <!--                                        Продажи (по подразделениям)-->
            <!--                                    </div>-->
            <!--                                    <div class="column__item">-->
            <!--                                        Продажи с менеджером ОП-->
            <!--                                    </div>-->
            <!--                                    <div class="column__item">-->
            <!--                                        Продажи и оплаты по клиентам + телефон-->
            <!--                                    </div>-->
            <!--                                </div>-->
            <!--                            </Block>-->
            <!--                            <Block :padding="0" :withBorder="true" :overflowHidden="true">-->
            <!--                                <div class="column">-->
            <!--                                    <div class="column__item heading">-->
            <!--                                        Маркетинг-->
            <!--                                    </div>-->
            <!--                                    <div class="column__item">-->
            <!--                                        Анализ источников привлечения клиентов-->
            <!--                                    </div>-->
            <!--                                    <div class="column__item">-->
            <!--                                        Конверсия первичного контакта-->
            <!--                                    </div>-->
            <!--                                    <div class="column__item">-->
            <!--                                        Конверсия сделок - (для руководства) обновленный-->
            <!--                                    </div>-->
            <!--                                    <div class="column__item">-->
            <!--                                        Отчет по задачам-->
            <!--                                    </div>-->
            <!--                                </div>-->
            <!--                            </Block>-->
            <!--                            <Block :padding="0" :withBorder="true" :overflowHidden="true">-->
            <!--                                <div class="column">-->
            <!--                                    <div class="column__item heading">-->
            <!--                                        Статистика-->
            <!--                                    </div>-->
            <!--                                    <div class="column__item">-->
            <!--                                        Динамика продаж-->
            <!--                                    </div>-->
            <!--                                    <div class="column__item">-->
            <!--                                        Статистика продления членств-->
            <!--                                    </div>-->
            <!--                                </div>-->
            <!--                            </Block>-->
            <!--                        </Grid>-->
          </v-container>

          <v-container class="col-10">
            <v-row>
              <v-col class="page-top d-flex justify-space-between" cols="12">
                <div>
                  <div class="page-title">Настройки</div>
                  <div class="breadcrumb">Настройки</div>
                </div>
              </v-col>
            </v-row>

            <v-sheet
                max-height="80px"
                rounded="lg"
                class="d-flex justify-space-between align-center card"
            >
              <v-tabs
                  centered
                  id="horizontal_tabs"
                  v-model="config_tab"
                  class="d-flex align-center schedule__tab"
              >
                <v-tab
                    v-for="item in configs"
                    :key="item.tab"
                    class="ml-4"
                >
                  {{ item.tab }}
                </v-tab>
              </v-tabs>
            </v-sheet>
            <v-sheet rounded="lg" class="card mt-5">
              <v-col>
                <v-tabs-items v-model="config_tab">
                  <v-tab-item>
                    <v-textarea
                        rows="8"
                        wrap="off"
                        style="width: 50%;"
                        v-model="settings"
                    >
                    </v-textarea>
                    <v-btn
                        class="button__lighten ml-3"
                        @click="getSettingsFrom1C"
                        style="margin-top: 0 !important; cursor: pointer;"
                    >
                      Получить UIS настройки из 1С
                    </v-btn>
                  </v-tab-item>
                  <v-tab-item>
                    <h2>Прочие настройки...</h2>
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-sheet>

          </v-container>

        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import AdminHeader from '@/components/Admin/AdminHeader.vue';
import AdminMenu from '@/components/Admin/AdminMenu.vue';
import {getItem} from "@/helpers/persistanceStorage";
import {uisActionTypes} from '@/store/modules/uis';

export default {
  name: 'AdminMain',
  components: {
    AdminHeader,
    AdminMenu,
  },
  data() {
    return {
      configs: [
        {tab: 'UIS Настройки'},
        {tab: 'Прочее'}
      ],
      config_tab: null,
      settings: null,
      selectCashbox: null,
      cashbox: JSON.parse(getItem('list-cashbox')) ?? [],
      headersCashbox: [
        {text: 'Название Юр. лица', value: 'legal_entity'},
        {text: 'ИНН Юр. лица', value: 'inn'},
        {text: 'Серийный номер кассы', value: 'serial'},
      ],
      showFilterGrid: false,
      rows: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    }
  },
  mounted() {
    this.fetchFeed()
  },
  methods: {
    fetchFeed() {
      this.$store.dispatch(uisActionTypes.getSettings)
          .then((response) => {
            if (!response.error) {
              this.settings = JSON.stringify(response.data[0], null, 4);
            }
          });
    },
    getSettingsFrom1C() {
      this.$store.dispatch(uisActionTypes.getSettings1c)
          .then((response) => {
            if (!response.error) {
              this.settings = JSON.stringify(response.data[0], null, 4);
            }
          });
    }
  }
}
</script>
<style scoped lang="scss">
.page-top {
  margin-bottom: 20px;
}

.column {
  &__item {
    padding: 12px 15px;
    color: #1A1A1A;
    font-family: 'Circe';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    background: #fff;

    &:not(:last-child) {
      border-bottom: 1px solid #E0E0E0;
    }

    &.heading {
      padding: 20px 15px;
      background: #F1F1F1;
      font-size: 16px;
      line-height: 24px;
    }
  }
}
</style>